import React from 'react'

import { Box } from 'system'

export const Dot = ({ size = '0.5rem', color = 'purple.50', ...props }) => (
  <Box bg={color} width={size} height={size} borderRadius="50%" {...props} />
)
